import { inject, Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { Manufacturer, SearchCriteria } from "@raptor-fe/core";
import { ServiceUtils } from '../service-utils/service-utils';
import { Observable, of } from "rxjs";
import { LoadingHeaders } from "../web-loading-service/web-loading-headers";

@Injectable({
    providedIn: 'root',
})
export class ManufacturerApiService {
    private readonly http = inject(HttpClient);
    private readonly serviceUtils = inject(ServiceUtils);
    private httpHeadersWithNoLoading = LoadingHeaders.httpHeadersWithNoLoading();

    delete(tenantId: string, id: string): Observable<object> {
        return this.http.delete(this.serviceUtils.getBaseUrl('manufacturer', tenantId) + `/${id}`);
    }

    getById(tenantId: string, id: string | null): Observable<Manufacturer | null> {
        if (!id || id === null) return of(<Manufacturer>{ id: null, tenantId: tenantId });

        return this.http.get<Manufacturer>(this.serviceUtils.getBaseUrl('manufacturer', tenantId) + `/${id}`);
    }

    save(tenantId: string, manufacturer: Manufacturer): Observable<Manufacturer> {
        if (!manufacturer.id || manufacturer.id === null) return this.http.post<Manufacturer>(this.serviceUtils.getBaseUrl('manufacturer', tenantId), manufacturer);
        else return this.http.put<Manufacturer>(this.serviceUtils.getBaseUrl('manufacturer', tenantId), manufacturer);
    }

    search(tenantId: string, searchCriteria: SearchCriteria, showLoading = true): Observable<Manufacturer[]> {
        return this.http.post<Manufacturer[]>(this.serviceUtils.getBaseUrl('manufacturer', tenantId) + `/search`, searchCriteria, {
            headers: showLoading ? undefined : this.httpHeadersWithNoLoading,
        });
    }

    sync(tenantId: string): Observable<object> {
        return this.http.post(this.serviceUtils.getBaseUrl('manufacturer', tenantId) + '/sync', {});
    }
}